/** 各区块标题右侧副标题：固定英文，不随语言切换 */
const sectionSubtitles = {
  news: 'TRENDING NEWS',
  spots: 'VIBRANT CITY OF MOUNTAINS & SEA',
  intComm: 'GLOBAL OUTREACH',
  photoDepot: 'PHOTO GALLERY',
  visual: 'VISUAL QINGDAO',
  release: 'QD RELEASE',
  vr: 'VR GALLERY',
  ask: 'SERVICES HUB',
};

const zh = {
  header: {
    searchPlaceholder: '搜索新闻、活动、图集...',
    searchPlaceholderMobile: '搜时事、图文、VR特展...',
    signIn: '登录',
    foreignResidentHub: '在线政务市民中心',
    copyright: 'Qingdao 国际新闻中心 版权所有 · 2026',
  },
  nav: {
    home: '首页',
    trendingNews: '城市新闻热榜',
    vibrantCity: '山海名城',
    globalOutreach: '国际传播',
    photoGallery: '青岛图片库',
    visualQingdao: '视觉青岛',
    qdRelease: '青岛发布',
    servicesHub: '问青岛服务平台',
  },
  categories: {
    news: '新闻',
    photos: '图库',
    videos: '视频',
    vr: 'VR展馆',
  },
  common: {
    viewMore: '更多详情',
    recommended: '推荐',
    worldSubtitle: 'THE WORLD IS IN QINGDAO',
  },
  sections: {
    news: {
      subtitle: sectionSubtitles.news,
      title: '城市新闻热榜',
      glance: '新闻速览',
      viewDetail: '查看新闻详情',
    },
    slogan: {
      prefix: '这里是',
      main: '青岛',
      carouselLabel: 'Slogan carousel',
      goToSlide: '切换到第 {n} 张',
    },
    spots: {
      subtitle: sectionSubtitles.spots,
      title: '山海名城 活力青岛',
      labels: ['青岛故事简介', '青岛越有young简介', '全民阅读简介', '青年榜young简介'],
    },
    intComm: {
      subtitle: sectionSubtitles.intComm,
      title: '国际传播',
      worldInQd: '世界在青岛',
      qdInWorld: '青岛在世界',
      ready: '我们，准备好了！',
      heroTitle: '从"青春"出发 为青岛而战',
      filters: ['在青外籍人士故事', '青岛企业出海记', '全球媒体看青岛', '青岛与友城动态'],
      items: {
        'int-1': { tag: '国际赛事与活动', title: '荣耀归航 共话精彩', summary: '2025-26克利伯环球帆船赛青岛站媒体见面会举办' },
        'int-2': { tag: '国际赛事与活动', title: '风帆为媒 山海相约', summary: '2025-26克利伯环球帆船赛青岛站颁奖仪式举行' },
        'int-3': { tag: '在青外籍人士故事', title: '啤酒狂欢 文化交融', summary: '青岛国际啤酒节狂欢夜，世界客商共叙海风情谊' },
        'int-4': { tag: '青岛企业出海记', title: '乘风破浪 极速出海', summary: '青岛智能高端动力装备亮相全球，签订亿元级跨国采购订单' },
        'int-5': { tag: '全球媒体看青岛', title: '山海之声 奏响维也纳金厅', summary: '青岛交响乐团欧洲巡演：在金色大厅奏响绝美东方山海乐章' },
        'int-6': { tag: '青岛与友城动态', title: '崂山香茗 法国浪漫碰撞', summary: '中法建交文化纪念周上，崂山茶艺演出折服塞纳河畔数万观众' },
      },
    },
    photoDepot: {
      subtitle: sectionSubtitles.photoDepot,
      title: '青岛图片库',
      dailyView: '每日一景',
      weeklyFeature: '本周精选 摄影专题',
      picks: '推荐',
      slideGroup: '第 {n} 组',
      next: '下一组',
      viewPicDetail: '查看图片详情',
      exitPreview: '退出预览',
      prevImage: '上一张',
      nextImage: '下一张',
      sectionIntro: '专题简介',
      imageCounter: '{current} / {total}',
      imageMeta: '图片信息',
      loadingDetail: '正在加载图片详情...',
      dragHint: '按住拖动可切换图片',
    },
    visual: {
      subtitle: sectionSubtitles.visual,
      title: '视觉青岛',
      scrollHint: '鼠标滚轮或右侧指示器切换视频',
      prev: '上一条',
      next: '下一条',
    },
    release: {
      subtitle: sectionSubtitles.release,
      title: '青岛发布',
    },
    vr: {
      subtitle: sectionSubtitles.vr,
      title: 'VR展馆',
      enter: '点击进入',
    },
    ask: {
      subtitle: sectionSubtitles.ask,
      title: '问青岛服务平台',
      cards: {
        'srv-1': ['12366税务服务。', '在线咨询'],
        'srv-2': ['海外人员', '居住登记'],
        'srv-3': ['在线查看外国人。', '申请状态'],
        'srv-4': ['进展查询', '关于外国人的作品', '中国的许可。'],
        'srv-5': ['首次申请', '居住', '学生许可'],
        'srv-6': ['扩展', '居留许可', '(外国人)'],
        'srv-7': ['护照更改', '不。(居留许可)', '(外国人)'],
        'srv-8': ['地址变更', '居留许可 (外国)', '全国购)'],
      },
    },
  },
  search: {
    searching: '正在为您检索: "{query}"...',
  },
};

const en = {
  header: {
    searchPlaceholder: 'Search portal documents...',
    searchPlaceholderMobile: 'Search...',
    signIn: 'Sign In',
    foreignResidentHub: 'Foreign Resident Hub',
    copyright: 'Qingdao International PR Office · 2026',
  },
  nav: {
    home: 'Home',
    trendingNews: 'Trending News',
    vibrantCity: 'Vibrant City of Mountains & Sea',
    globalOutreach: 'Global Outreach',
    photoGallery: 'Photo Gallery',
    visualQingdao: 'Visual Qingdao',
    qdRelease: 'QD Release',
    servicesHub: 'Services Hub',
  },
  categories: {
    news: 'News',
    photos: 'Photos',
    videos: 'Videos',
    vr: 'VR Gallery',
  },
  common: {
    viewMore: 'View More',
    recommended: 'Picks',
    worldSubtitle: 'THE WORLD IS IN QINGDAO',
  },
  sections: {
    news: {
      subtitle: sectionSubtitles.news,
      title: 'Trending News',
      glance: 'News Glance',
      viewDetail: 'View news detail',
    },
    slogan: {
      prefix: 'This is',
      main: 'Qingdao',
      carouselLabel: 'Slogan carousel',
      goToSlide: 'Go to slide {n}',
    },
    spots: {
      subtitle: sectionSubtitles.spots,
      title: 'Vibrant City of Mountains & Sea',
      labels: ['Qingdao Story Intro', 'Qingdao is YOUNG Intro', 'Public Reading Intro', 'Youth List YOUNG Intro'],
    },
    intComm: {
      subtitle: sectionSubtitles.intComm,
      title: 'Global Outreach',
      worldInQd: 'The World in Qingdao',
      qdInWorld: 'Qingdao in the World',
      ready: 'We are ready!',
      heroTitle: 'Starting from Youth, Fighting for Qingdao',
      filters: ['Expat Stories', 'Enterprise Sailing', 'Global PR Coverage', 'Sister Cities'],
      items: {
        'int-1': { tag: 'Global Events', title: 'Glory Return, Ocean Celebration', summary: '2025-26 Clipper Round the World Yacht Race Press Meeting Held' },
        'int-2': { tag: 'Global Events', title: 'Sails as Medium, Mount & Sea', summary: '2025-26 Clipper Round the World Yacht Race Award Ceremony Held' },
        'int-3': { tag: 'Expat Tales', title: 'Beer Carnival, Culture Harmony', summary: 'Qingdao Beer Festival Night: Global Partners Cherish Partnership' },
        'int-4': { tag: 'Brands Sailing Out', title: 'Riding Winds, Speeding Overseas', summary: 'Qingdao Smart Power Equipment Debuts Globally with Multi-Million Contracts' },
        'int-5': { tag: 'Global PR View', title: 'Sound of Ocean at Vienna Golden Hall', summary: 'Qingdao Symphony Orchestra European Tour Rocks Vienna Hall' },
        'int-6': { tag: 'Sister Cities', title: 'Laoshan Tea Meets Parisian Romance', summary: 'Laoshan Art Tea Show Captivates Thousands of French Visitors' },
      },
    },
    photoDepot: {
      subtitle: sectionSubtitles.photoDepot,
      title: 'Photo Gallery',
      dailyView: 'Daily View',
      weeklyFeature: 'Weekly Photo Feature',
      picks: 'Picks',
      slideGroup: 'Slide {n}',
      next: 'Next',
      viewPicDetail: 'View image detail',
      exitPreview: 'Exit preview',
      prevImage: 'Previous image',
      nextImage: 'Next image',
      sectionIntro: 'Feature overview',
      imageCounter: '{current} / {total}',
      imageMeta: 'Image details',
      loadingDetail: 'Loading image details...',
      dragHint: 'Drag left or right to switch',
    },
    visual: {
      subtitle: sectionSubtitles.visual,
      title: 'Visual Qingdao',
      scrollHint: 'Scroll or use rail to switch videos',
      prev: 'Previous',
      next: 'Next',
    },
    release: {
      subtitle: sectionSubtitles.release,
      title: 'QD Release',
    },
    vr: {
      subtitle: sectionSubtitles.vr,
      title: 'VR Gallery',
      enter: 'Enter',
    },
    ask: {
      subtitle: sectionSubtitles.ask,
      title: 'Services Hub',
      cards: {
        'srv-1': ['12366 Tax Service.', 'Online Consultation'],
        'srv-2': ['Foreign Residents', 'Residency Registry'],
        'srv-3': ['Check Foreigners Online.', 'Application Status'],
        'srv-4': ['Progress Query', 'Foreign Works', 'Chinese Permit.'],
        'srv-5': ['First Application', 'Residency', 'Student Permit'],
        'srv-6': ['Extension', 'Residency Permit', '(Foreigner)'],
        'srv-7': ['Passport Update', 'No. (Residency Permit)', '(Foreigner)'],
        'srv-8': ['Address Update', 'Residency Permit (Foreign)', 'Nationwide Purchase)'],
      },
    },
  },
  search: {
    searching: 'Searching portal databases for: "{query}"...',
  },
};

const zhCHT = {
  ...en,
  header: {
    searchPlaceholder: '搜索新聞、活動、圖集...',
    searchPlaceholderMobile: '搜時事、圖文、VR特展...',
    signIn: '登錄',
    foreignResidentHub: '在線政務市民中心',
    copyright: 'Qingdao 國際新聞中心 版權所有 · 2026',
  },
  nav: {
    home: '首頁',
    trendingNews: '城市新聞熱榜',
    vibrantCity: '山海名城',
    globalOutreach: '國際傳播',
    photoGallery: '青島圖片庫',
    visualQingdao: '視覺青島',
    qdRelease: '青島發布',
    servicesHub: '問青島服務平台',
  },
  categories: {
    news: '新聞',
    photos: '圖庫',
    videos: '視頻',
    vr: 'VR展馆',
  },
  common: {
    viewMore: '更多詳情',
    recommended: '推薦',
    worldSubtitle: 'THE WORLD IS IN QINGDAO',
  },
  sections: {
    ...en.sections,
    news: { subtitle: sectionSubtitles.news, title: '城市新聞熱榜', glance: '新聞速覽', viewDetail: '查看新聞詳情' },
    slogan: { prefix: '這裡是', main: '青島', carouselLabel: 'Slogan carousel', goToSlide: '切換到第 {n} 張' },
    spots: {
      subtitle: sectionSubtitles.spots,
      title: '山海名城 活力青島',
      labels: ['青島故事簡介', '青島越有young簡介', '全民閱讀簡介', '青年榜young簡介'],
    },
    intComm: {
      subtitle: sectionSubtitles.intComm,
      title: '國際傳播',
      worldInQd: '世界在青島',
      qdInWorld: '青島在世界',
      ready: '我們，準備好了！',
      heroTitle: '從"青春"出發 為青島而戰',
      filters: ['在青外籍人士故事', '青島企業出海記', '全球媒體看青島', '青島與友城動態'],
      items: {
        'int-1': { tag: '國際賽事與活動', title: '榮耀歸航 共話精彩', summary: '2025-26克利伯環球帆船賽青島站媒體見面會舉辦' },
        'int-2': { tag: '國際賽事與活動', title: '風帆為媒 山海相約', summary: '2025-26克利伯環球帆船賽青島站頒獎儀式舉行' },
        'int-3': { tag: '在青外籍人士故事', title: '啤酒狂歡 文化交融', summary: '青島國際啤酒節狂歡夜，世界客商共敘海風情誼' },
        'int-4': { tag: '青島企業出海記', title: '乘風破浪 極速出海', summary: '青島智能高端動力裝備亮相全球，簽訂億元級跨國採購訂單' },
        'int-5': { tag: '全球媒體看青島', title: '山海之聲 奏響維也納金廳', summary: '青島交響樂團歐洲巡演：在金色大廳奏響絕美東方山海樂章' },
        'int-6': { tag: '青島與友城動態', title: '嶗山香茗 法國浪漫碰撞', summary: '中法建交文化紀念周上，嶗山茶藝演出折服塞納河畔數萬觀眾' },
      },
    },
    photoDepot: {
      subtitle: sectionSubtitles.photoDepot,
      title: '青島圖片庫',
      dailyView: '每日一景',
      weeklyFeature: '本週精選 攝影專題',
      picks: '推薦',
      slideGroup: '第 {n} 組',
      next: '下一組',
      viewPicDetail: '查看圖片詳情',
      exitPreview: '退出預覽',
      prevImage: '上一張',
      nextImage: '下一張',
      sectionIntro: '專題簡介',
      imageCounter: '{current} / {total}',
      imageMeta: '圖片信息',
      loadingDetail: '正在加載圖片詳情...',
      dragHint: '按住拖動可切換圖片',
    },
    visual: { subtitle: sectionSubtitles.visual, title: '視覺青島', scrollHint: '滑鼠滾輪或右側指示器切換視頻', prev: '上一條', next: '下一條' },
    release: { subtitle: sectionSubtitles.release, title: '青島發布' },
    vr: { subtitle: sectionSubtitles.vr, title: 'VR展馆', enter: '點擊進入' },
    ask: {
      subtitle: sectionSubtitles.ask,
      title: '問青島服務平台',
      cards: {
        'srv-1': ['12366稅務服務。', '在線諮詢'],
        'srv-2': ['海外人員', '居住登記'],
        'srv-3': ['在線查看外國人。', '申請狀態'],
        'srv-4': ['進展查詢', '關於外國人的作品', '中國的許可。'],
        'srv-5': ['首次申請', '居住', '學生許可'],
        'srv-6': ['擴展', '居留許可', '(外國人)'],
        'srv-7': ['護照更改', '不。(居留許可)', '(外國人)'],
        'srv-8': ['地址變更', '居留許可 (外國)', '全國購)'],
      },
    },
  },
  search: { searching: '正在為您檢索: "{query}"...' },
};

export default { zh, en, zhCHT, ja: en, ko: en, ru: en, de: en, ar: en };
